interface MaxWidthLineBreakProps {
  /** Widest viewport, in px, that still breaks the line. */
  maxWidth?: number;
  /** The same width as written in copy: `<break max-width='415'/>` (see LINE_BREAKS). */
  "max-width"?: string;
}

/**
 * A <br> that only applies on viewports up to `maxWidth`. Wider ones keep the text on one
 * line, with the space before the break separating the words. Without a width it's a
 * plain <br>.
 */
export function MaxWidthLineBreak({ maxWidth, "max-width": maxWidthAttr }: MaxWidthLineBreakProps) {
  const parsed = maxWidth ?? Number(maxWidthAttr);
  if (!Number.isFinite(parsed)) return <br />;

  const width = Math.round(parsed);
  return (
    <>
      {/* React hoists this into <head> (server render included) and keeps one copy per
          width, however many breaks share it. */}
      <style href={`max-width-line-break-${width}`} precedence="default">
        {`@media (width > ${width}px) { br[data-max-width="${width}"] { display: none; } }`}
      </style>
      {/* Hangs invisibly at the end of the line while the break shows. */}{" "}
      <br data-max-width={width} />
    </>
  );
}

/**
 * Pass to <Trans components> so copy can place its own breaks, each with its own width:
 * "work with<break max-width='415'/>my vehicle". Trans hands the tag's attributes to the
 * component as props; a <break/> with no width is a plain <br>.
 */
export const LINE_BREAKS = { break: <MaxWidthLineBreak /> };
